import {IGlobals} from '../../galleryGlobalStrategy';

export const shouldShowGalleryAppInLayout = (isLoaded, {showShowLightEmptyState}: IGlobals) => {
  return isLoaded && !showShowLightEmptyState;
};
